export const LOADING_POLITICS_AND_PROCEDURES = "LOADING_POLITICS_AND_PROCEDURES";
export const SAVE_LOADING_POLITICS_AND_PROCEDURES = "SAVE_LOADING_POLITICS_AND_PROCEDURES";
export const GET_POLITICS_AND_PROCEDURES = "GET_POLITICS_AND_PROCEDURES";
export const FORM_FAIL = "FORM_FAIL";
export const FORM_FAIL_JSON = "FORM_FAIL_JSON";
export const POLITICS_AND_PROCEDURES_FAIL = "POLITICS_AND_PROCEDURES_FAIL";
export const LOADING_POLITICS_AND_PROCEDURES_BY_ID = "LOADING_POLITICS_AND_PROCEDURES_BY_ID";
export const GET_POLITICS_AND_PROCEDURES_BY_ID = "GET_POLITICS_AND_PROCEDURES_BY_ID";

